import { EntityState, EntityStore, EntityActions, QueryEntity, getEntityType, getIDType } from '@datorama/akita';
import { OnDestroy } from '@angular/core';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Observable, Subject, Subscription } from 'rxjs';
import { takeUntilDestroyed } from 'projects/core/src/public-api';
import { RxJSUnsubscribe } from 'projects/core/src/lib/core/utils/decorators/rxjs-unsubscribe-decorator';
import { RxJSUnsubscribable } from 'projects/core/src/lib/core/utils/interfaces/rxjs-unsubscribable';

export interface Entity {
    id: number;
}

@RxJSUnsubscribe
export class AbstractEntityStore<S extends EntityState = any, EntityType extends Entity = getEntityType<S>> extends EntityStore<S, EntityType, number> implements OnDestroy, RxJSUnsubscribable {

    protected syncToQueryUpdates<QS extends EntityState = any>(query: QueryEntity<QS, EntityType, number>): Subscription {
        return this.selectQueryUpdate(query)
            .pipe(
                takeUntil(this.getUnsubFromAllSubs())
            )
            .subscribe(updatedEntities => {
                this.upsertMany(updatedEntities)
            })
    }

    protected selectQueryUpdate<QS extends EntityState = any>(query: QueryEntity<QS, EntityType, number>): Observable<EntityType[]> {
        return this.selectQueryAction(query, EntityActions.Update)
    }

    protected selectQueryAction<QS extends EntityState = any>(query: QueryEntity<QS, EntityType, number>, action: EntityActions): Observable<EntityType[]> {
        return query
            .selectEntityAction(action)
            .pipe(
                map(ids => {
                    return ids.filter(id => this._value().ids.includes(id))
                }),
                filter(ids => ids.length > 0),
                map(ids => {
                    return query.getAll({
                        filterBy: entity => ids.includes(entity.id)
                    })
                })
            )
    }

    getUnsubFromAllSubs(): Subject<boolean> {
        return null
    }
}